function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "AE41119F-5338-4539-AD7D-C41D21307EAF");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.");

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M1.79787632,10.850271 C1.68526612,10.9486791 1.59071462,11.2710701 1.61991923,11.7643035 C1.6541139,12.3418135 1.85702651,12.8762543 2.07520911,13.0792871 C2.10561015,13.0961037 2.13371059,13.1165712 2.15891886,13.140098 C2.16012698,13.1407253 2.16133498,13.1413416 2.16254282,13.1419466 L11.8817907,17.6277534 L23.8968508,10.869282 C24.0995278,10.7552762 24.3562499,10.8271584 24.4702557,11.0298354 C24.5842615,11.2325124 24.5123793,11.4892346 24.3097023,11.6032404 L12.1071207,18.4671927 C11.9893487,18.5334394 11.8469377,18.5391376 11.7242493,18.4825122 L1.7979015,13.9008945 C1.68528021,13.9992766 1.59071244,14.3216788 1.61991923,14.8149491 C1.65865294,15.4691184 1.91386906,16.0680256 2.16254282,16.1925921 L11.8817907,20.6783989 L23.8968508,13.9199276 C24.0995278,13.8059217 24.3562499,13.8778039 24.4702557,14.0804809 C24.5842615,14.2831579 24.5123793,14.5398801 24.3097023,14.6538859 L12.1071207,21.5178382 C11.9893487,21.5840849 11.8469377,21.5897831 11.7242493,21.5331577 L1.79779682,16.9514917 C1.20301592,16.6541013 0.833956439,15.7880417 0.779286276,14.8647234 C0.739867434,14.1989829 0.873258553,13.6200657 1.194542,13.2977942 C0.956635665,12.8961932 0.811926848,12.3653409 0.779286276,11.8140778 C0.740180559,11.1536257 0.871150263,10.5786229 1.18692118,10.2548771 C0.903778591,9.79300255 0.745183694,9.1596743 0.745183694,8.5335794 C0.745183694,7.73481632 1.03180895,7.11118623 1.54618428,6.95331854 L11.696515,0.991563067 C12.6179849,0.480620207 13.7135671,0.386713171 14.7330556,0.742794848 L24.266323,4.74676686 C24.5893179,4.8824247 24.6150397,5.33019742 24.3097035,5.50194899 L12.1071212,12.365901 C11.9877014,12.4330747 11.8430646,12.4379405 11.7194002,12.3789446 C11.6432622,12.3426219 11.6432622,12.3426219 11.3000402,12.1790394 C10.9662429,12.019992 10.5940097,11.8427647 10.1927879,11.6519033 C9.04645968,11.1065946 7.89751873,10.56129 6.8215644,10.052368 L6.75755676,10.0220949 C4.27603731,8.8485213 2.57058153,8.05198828 2.0096422,7.80941994 C1.73868296,7.69224838 1.58728898,7.89355848 1.58728898,8.5335794 C1.58728898,9.15788541 1.80862006,9.7896861 2.06434167,10.0228366 C2.09900051,10.0407013 2.13085947,10.0632362 2.15908669,10.0896092 C2.16023854,10.0901817 2.16139061,10.0907455 2.16254289,10.0913005 L11.8817913,14.5771071 L23.896852,7.81863601 C24.099529,7.7046302 24.3562511,7.7765124 24.4702569,7.97918939 C24.5842628,8.18186638 24.5123806,8.43858852 24.3097035,8.55259432 L12.1071212,15.4165463 C11.9893492,15.4827931 11.8469383,15.4884913 11.7242499,15.4318659 L1.80343812,10.8529683 C1.80158211,10.8520746 1.79972818,10.8511755 1.79787632,10.850271 Z M2.75515933,7.2198346 C3.54885639,7.57986426 5.06632585,8.29074021 7.11757861,9.26082983 L7.18163016,9.2911237 C8.25820919,9.80034131 9.40768716,10.3459007 10.5545333,10.8914559 C10.9559225,11.0823969 11.3283155,11.2597004 11.662268,11.4188217 C11.7618956,11.466305 11.8326207,11.5000133 11.8846911,11.5248313 L23.146838,5.1898736 L14.4314733,1.52860681 C13.6629163,1.26082249 12.8166509,1.33335953 12.1139415,1.72285467 L2.75515933,7.2198346 Z",
  id: "path-3"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "Dashboard",
  stroke: "none",
  strokeWidth: 1,
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Users",
  transform: "translate(-322.000000, -123.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Menu",
  transform: "translate(0.000000, 92.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Course-not-selected",
  transform: "translate(318.000000, 23.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-5",
  transform: "translate(0.000000, 3.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icons/Courses"
}, /*#__PURE__*/React.createElement("g", {
  id: "Color/Primary/Brand",
  transform: "translate(3.368421, 4.954404)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-3",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-3"
})), /*#__PURE__*/React.createElement("use", {
  id: "Mask",
  fill: "#EAECF0",
  fillRule: "nonzero",
  xlinkHref: "#path-3"
}), /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask-3)",
  id: "Rectangle-Copy-3"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-3.368421, -5.052632)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 0,
  y: 0,
  width: 32,
  height: 32
}))))))))));

var SvgCourses = function SvgCourses(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "22px",
    viewBox: "0 0 24 22",
    fill: "#9FA5B7",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCourses, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Courses.2b34f5e2.svg";
export { ForwardRef as ReactComponent };